var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 6.27084C7.24163 6.27084 7.43751 6.46672 7.43751 6.70834V9.62501C7.43751 9.86663 7.24164 10.0625 7.00001 10.0625C6.75839 10.0625 6.56251 9.86664 6.56251 9.62501V6.70834C6.56251 6.46672 6.75839 6.27084 7.00001 6.27084Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00001 5.25001C7.32218 5.25001 7.58334 4.98884 7.58334 4.66668C7.58334 4.34451 7.32218 4.08334 7.00001 4.08334C6.67784 4.08334 6.41668 4.34451 6.41668 4.66668C6.41668 4.98884 6.67784 5.25001 7.00001 5.25001Z",
    fill: "#BDBDBD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.89584 7.00001C1.89584 4.18106 4.18106 1.89584 7.00001 1.89584C9.81896 1.89584 12.1042 4.18106 12.1042 7.00001C12.1042 9.81896 9.81896 12.1042 7.00001 12.1042C4.18106 12.1042 1.89584 9.81896 1.89584 7.00001ZM7.00001 2.77084C4.66431 2.77084 2.77084 4.66431 2.77084 7.00001C2.77084 9.33571 4.66431 11.2292 7.00001 11.2292C9.33571 11.2292 11.2292 9.33571 11.2292 7.00001C11.2292 4.66431 9.33571 2.77084 7.00001 2.77084Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/Info-circle.b8b7eb3c336deb8abb9547dbe095c925.svg";
export { ForwardRef as ReactComponent };